var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceDropdownUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 6,
    viewBox: "0 0 13 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 4.5l5.333-3 5.334 3",
    stroke: "#C4CCE5",
    strokeWidth: 2
  })));
}
export default __webpack_public_path__ + "media/navbar/serviceDropdownUp-5118b85a.svg";
export { SvgServiceDropdownUp as ReactComponent };